
import { useQuery } from '@tanstack/react-query';
import * as procurementService from '@/services/procurementService';
import { useAuth } from '@/contexts/AuthContext';

export const useGetProcurements = () => {
  const { user, userRole } = useAuth();
  
  return useQuery({
    queryKey: ['procurements', user?.id, userRole],
    queryFn: () => procurementService.getProcurements(user?.id, userRole)
  });
};

export const useGetCurrentProcurement = () => {
  return useQuery({
    queryKey: ['procurements', 'current'],
    queryFn: procurementService.getCurrentProcurement
  });
};

export const useGetProcurementByHarvestId = (harvestId: string) => {
  return useQuery({
    queryKey: ['procurements', harvestId],
    queryFn: () => procurementService.getProcurementByHarvestId(harvestId),
    enabled: !!harvestId
  });
};

export const useGetProcurementById = (id: string) => {
  return useQuery({
    queryKey: ['procurement', id],
    queryFn: () => procurementService.getProcurementById(id),
    enabled: !!id
  });
};

/**
 * Optimized hook for warehouse inspection - fetches only essential data
 */
export const useGetWarehouseInspectionProcurement = (id: string) => {
  return useQuery({
    queryKey: ['warehouse-inspection-procurement', id],
    queryFn: async () => {
      const { getWarehouseInspectionProcurement } = await import('@/services/procurement/warehouseInspectionService');
      return getWarehouseInspectionProcurement(id);
    },
    enabled: !!id,
    staleTime: 1000 * 60 * 5, // 5 minutes cache for inspection data
  });
};
